import HTTP from "@/utils/http";
const http = new HTTP();

export function apiGetTemplateData(params) {
    return http.get({
        url: "/cmscore/template/data",
        params,
    });
}

